module.exports = __webpack_public_path__ + "img/ic_location.0d11e553.svg";